import React from 'react';

interface ConversationDisplayProps {
  lastTranscription: string | null;
  lastResponse: string | null;
}

export function ConversationDisplay({
  lastTranscription,
  lastResponse
}: ConversationDisplayProps) {
  if (!lastTranscription && !lastResponse) return null;

  return (
    <div className="overflow-y-auto conversation-scroll">
      {lastTranscription && (
        <div className="p-2">
          <div className="message-user p-3 rounded-lg text-sm">
            <p className="text-primary">{lastTranscription}</p>
          </div>
        </div>
      )}
      
      {lastResponse && (
        <div className="p-2">
          <div className="message-ai p-3 rounded-lg text-sm">
            <p className="text-primary">{lastResponse}</p>
          </div>
        </div>
      )}
    </div>
  );
} 